import { heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[600px] flex items-center bg-background-100 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20warm%20crimson%20and%20deep%20amber%20gradient%20background%20with%20overlapping%20translucent%20shapes%20representing%20breaking%20news%20and%20social%20media%20trends%2C%20soft%20diffused%20glow%20effects%2C%20modern%20editorial%20design%2C%20dark%20edges%2C%20Chinese%20entertainment%20media%20aesthetic%2C%20high%20contrast%20atmospheric%20lighting&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="吃瓜群背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/50 to-black/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/20 border border-accent-400/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
              <span className="text-xs font-medium text-accent-300 whitespace-nowrap">
                实时吃瓜爆料更新中
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
              吃瓜群
              <span className="block text-lg md:text-2xl lg:text-3xl font-body font-light text-foreground-200 mt-2">
                吃瓜群众在线爆料第一站
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-200 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              这里汇聚了最全的吃瓜群众在线爆料内容。从最新内幕到实时爆料，从娱乐圈突发事件到行业深度揭秘，在线爆料大全不间断更新。无论你是资深瓜友还是路过吃瓜群众，这里都有你想要的精彩内容。
            </p>

            <p className="text-sm text-foreground-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
              当前正值娱乐圈活动密集期，多个重磅爆料轮番上线，是吃瓜的最佳时机。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-6 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-400 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-base" />
                查看热度榜
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 font-medium text-sm rounded-lg hover:bg-background-50/25 border border-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-time-line text-base" />
                最新快讯
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20abstract%20composition%20of%20overlapping%20newspaper%20clippings%20and%20smartphone%20screens%20showing%20trending%20social%20media%20topics%2C%20warm%20crimson%20and%20amber%20glowing%20accents%2C%20dark%20atmospheric%20background%2C%20modern%20digital%20media%20aesthetic%2C%20Chinese%20entertainment%20news%20vibe%2C%20high%20contrast%2C%20editorial%20design%20style&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="吃瓜群主视觉 - 实时吃瓜爆料"
                className="w-full h-auto rounded-xl"
              />
              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2 px-3 py-2 rounded-lg bg-black/50 backdrop-blur-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
                <span className="text-xs text-background-50 font-medium whitespace-nowrap">
                  实时在线 38.2 万瓜友正在吃瓜
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}